// Libs
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'leaflet'

// Utils
// import traverse from 'utils/traverse'

// Styles
import { white } from 'fc-styles/src/colors'

const componentStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 2000,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'flex-start',
}

const messageStyle = {
  padding: 15,
  fontSize: 14,
  margin: 15,
  backgroundColor: white(0.7),
  borderRadius: 2,
  boxShadow: '0 0 2px rgba(0,0,0,0.2)',
}

// Exports
export default class SelectCoordinateMessage extends Component {
  constructor () {
    super()

    this.onMapClick = this.onMapClick.bind(this)
  }

  componentDidMount () {
    this._isMounted = true
    this.context.map.on('click', this.onMapClick)
  }

  componentWillUnmount () {
    if (this._isMounted) {
      this.context.map.off('click', this.onMapClick)
    }
  }

  onMapClick ({latlng}) {
    this.props.onCreateSpatial()
  }

  render () {
    return (
      <div style={componentStyle}>
        <div style={messageStyle}>
            Select a location on the map to start drawing.
        </div>
      </div>
    )
  }
}

SelectCoordinateMessage.propTypes = {
  onCreateSpatial: PropTypes.func.isRequired,
}

SelectCoordinateMessage.contextTypes = {
  map: PropTypes.instanceOf(Map),
}
